// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__eyreS","bigColWidth":"Table_bigColWidth__3DifA","biggerColWidth":"Table_biggerColWidth__23zlO","row":"Table_row__2uUeK","col":"Table_col__1kcOj"};